import { __t, applyTranslations } from './language';

applyTranslations(require('./i18n/profile-util.i18n.json'));

import type { Image } from 'types/Image.type';
import type { ApprovalStatus, BrandProfileManagedBy } from 'types';

type GetApprovalStatusProfile = {
  approvalStatus: ApprovalStatus
} | {
  approvalStatus?: ApprovalStatus
};

export const APPROVAL_STATUS_APPROVED = 'approved';
export const APPROVAL_STATUS_REJECTED = 'rejected';
export const APPROVAL_STATUS_PENDING = 'pending';
export const APPROVAL_STATUS_DECLINED = 'declined';
export const REALM_APPROVAL_STATUS_INVITED = 'invited';

export const PROFILE_APPROVAL_STATUSES = [
  APPROVAL_STATUS_PENDING,
  APPROVAL_STATUS_APPROVED,
  APPROVAL_STATUS_REJECTED
];

export const REALM_PROFILE_APPROVAL_STATUSES = [
  APPROVAL_STATUS_PENDING,
  APPROVAL_STATUS_APPROVED,
  APPROVAL_STATUS_DECLINED,
  REALM_APPROVAL_STATUS_INVITED
];

export const AVAILABLE_STATE_TRANSITIONS = {
  [APPROVAL_STATUS_PENDING]: [APPROVAL_STATUS_APPROVED, APPROVAL_STATUS_REJECTED],
  [APPROVAL_STATUS_APPROVED]: [APPROVAL_STATUS_REJECTED],
  [APPROVAL_STATUS_REJECTED]: [APPROVAL_STATUS_APPROVED]
};

export function getApprovalStatus(profile?: GetApprovalStatusProfile): string | undefined | null {
  return (profile && profile.approvalStatus) || null;
}

export function getMissingImagesValidationError(profileImage?: Image | null, errorType: 'profile' | 'cover' = 'profile'): string | undefined | null {
  const hasProfileImage = profileImage && profileImage.url;

  if (!hasProfileImage) {
    return __t(`profile_util.missing_${errorType}_image`);
  }

  return null;
}

export function getManagedByBrand(profile?: { managedBy?: BrandProfileManagedBy } | null): BrandProfileManagedBy | undefined | null {
  if (!profile) {
    return null;
  }

  return profile.managedBy;
}

export function isInfluencerProfileRejected(profile?: GetApprovalStatusProfile): boolean {
  return getApprovalStatus(profile) === APPROVAL_STATUS_REJECTED;
}

export function isInfluencerProfileApproved(profile?: GetApprovalStatusProfile): boolean {
  return getApprovalStatus(profile) === APPROVAL_STATUS_APPROVED;
}
